import { FunctionComponent } from 'react';
import { useGameStateSlice, useBetSlice, Tooltip } from '@pp/core';
import { BetOnAll } from './BetOnAll';
import { useBetOnAllEnabled } from '@pp/core/src/store/apiHooks/useBetOnAllEnabled';
import { useIsPortraitMax } from '../../../hooks/useWindowDimension';
import { useAllLimitConnected } from '../hooks/useAllLimitConnected';
import styles from './BetOnAll.module.css';

export interface BetOnAllProps {
  clickSound?: string;
}
export const BetOnAllConnected: FunctionComponent<BetOnAllProps> = ({ clickSound }) => {
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();
  const balance = useGameStateSlice.getDeductibleBalance();
  const isLowBalance = useBetSlice.isLowBalance(balance);
  const betOnAllEnabled = useBetOnAllEnabled();
  const isPortraitMax = useIsPortraitMax();
  const multipleLimitTooltip = useAllLimitConnected();

  return (
    <>
      <div className={`${styles.betOnAllContainer} ${isPortraitMax ? styles.betOnAllMax : ''}`}>
        <Tooltip
          className={styles.betOnAllTooltip}
          text={multipleLimitTooltip || 'BETONALL'}
          displayOnTouch={Boolean(multipleLimitTooltip)}
          disabled={!isBetsOpenStatus || !betOnAllEnabled}
        >
          <BetOnAll
            isDisabled={!isBetsOpenStatus || !betOnAllEnabled}
            isCollapsed={!isBetsOpenStatus || isLowBalance}
            isMax={isPortraitMax}
            clickSound={clickSound}
          />
        </Tooltip>
      </div>
    </>
  );
};
